module.exports = __webpack_public_path__ + "img/main_bootm_middle.4cbc1037.png";